export const RESERVATION_OPTIONS = {
  VISIT_TYPE: "visitType",
  LANGUGAGE: "language",
  LOCATION: "online",
};

export const TRACKING = {
  INIT: "INIT",
  OPEN: "OPEN",
  SEARCH: "SEARCH",
  FORM: "FORM",
  HINTS: "HINTS",
  FINALIZED: "FINALIZED",
};

export const LEGAL_FORM = {
  1: "aip/startup",
  2: "działalność gospodarcza",
  3: "fundacja",
  6: "jednostki samorządu terytorialnego",
  7: "kościół/organizacja kościelna",
  8: "organizacja pożytku publicznego",
  10: "przedsiębiorstwo państwowe",
  11: "spółdzielnia",
  12: "spółka akcyjna",
  13: "spółka akcyjna w organizacji",
  14: "spółka cywilna",
  16: "spółka komandytowo-akcyjna",
  17: "spółka skarbu państwa",
  18: "spółka z o.o.",
  19: "spółka z o.o. w organizacji",
  20: "stowarzyszenie",
  21: "uczelnie, jednostki oświaty",
  22: "wspólnota mieszkaniowa",
  23: "inna",
  24: "spółka jawna",
  25: "spółka komandytowa",
  26: "spółka partnerska",
  27: "państwowa jednostka organizacyjna",
  28: "działalność gospodarcza zagraniczna",
  29: "spółka zagraniczna",
  30: "Prosta spółka akcyjna",
  33: "Instytut badawczy",
  34: "Publiczna instytucja kultury",
  36: "Osoba fizyczna prowadząca działalność nieewidencjonowaną",
};

export const OPTIONS_ORDER = ["Dziecko", "Osoba dorosła", "Para", "Rodzina"];
